import api, { baseURL } from './api';

export const REACTION_EMOJIS = ['👍', '🔥', '💚'];

export const fetchAnnouncements = () =>
  api.get('/announcements').then(res => res.data);

export const markAnnouncementsRead = () =>
  api.post('/announcements/read').then(res => res.data);

export const toggleReaction = (id, emoji) =>
  api.put(`/announcements/${id}/reactions`, { emoji }).then(res => res.data);

/* Opens the announcements SSE stream. EventSource sends no headers, so the
   token goes in the query string; the browser reconnects on its own when the
   connection drops, which is why the caller passes handlers rather than
   polling. `onError` fires when the connection ends for good — a rejected
   token closes the stream outright instead of retrying, so the caller has to
   reopen it with a fresh one. Returns a close function. */
export function openAnnouncementStream(handlers, onError) {
  const token = localStorage.getItem('token');
  if (!token) return () => {};

  const source = new EventSource(
    `${baseURL}/announcements/stream?token=${encodeURIComponent(token)}`
  );

  const listeners = Object.entries(handlers).map(([type, handler]) => {
    const listener = event => {
      try {
        handler(JSON.parse(event.data));
      } catch (err) {
        console.error(`Malformed ${type} announcement event:`, err);
      }
    };
    source.addEventListener(type, listener);
    return [type, listener];
  });

  source.onerror = () => {
    if (source.readyState === EventSource.CLOSED) onError?.();
  };

  return () => {
    source.onerror = null;
    listeners.forEach(([type, listener]) => source.removeEventListener(type, listener));
    source.close();
  };
}
